import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import { StateProvider } from './services/state-provider';
import registerServiceWorker from './registerServiceWorker';
import * as smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();
export function bootstrap() {
    StateProvider.setupStateManager();
    ReactDOM.render(React.createElement(App, null), document.getElementById('root'));
    registerServiceWorker();
}
//# sourceMappingURL=main.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/main.js
// module id = 985
// module chunks = 8